module.exports = __webpack_public_path__ + "static/timetravel_img2jpg-f50c48a8ca9e264d6181c3f6f40295d1.png";